import { Service } from '../../../store/types';
import { ActionType } from '../../actionTypes';
import { createApiRequestAction } from '../../helpers';
import {
  rollout as rolloutSchema,
  rolloutVersion as rolloutVersionSchema,
} from '../../schema';

export const fetchLatestRollout = (variableName: string) =>
  createApiRequestAction(ActionType.FETCH_LATEST_ROLLOUT_REQUESTED, {
    request: {
      method: 'GET',
      service: Service.PLANNER,
      url: `/v2/rollouts/${variableName}/`,
      normalizr: {
        key: 'rollout',
        schema: rolloutSchema,
      },
      responseTypes: {
        started: ActionType.FETCH_LATEST_ROLLOUT_STARTED,
        succeeded: ActionType.FETCH_LATEST_ROLLOUT_SUCCEEDED,
        failed: ActionType.FETCH_LATEST_ROLLOUT_FAILED,
      },
    },
  });

export const fetchRolloutVersion = (variableName: string, version: string) =>
  createApiRequestAction(ActionType.FETCH_ROLLOUT_VERSION_REQUESTED, {
    request: {
      method: 'GET',
      service: Service.PLANNER,
      url: `/v2/rollouts/${variableName}/versions/${version}/`,
      normalizr: {
        schema: rolloutVersionSchema,
      },
      responseTypes: {
        started: ActionType.FETCH_ROLLOUT_VERSION_STARTED,
        succeeded: ActionType.FETCH_ROLLOUT_VERSION_SUCCEEDED,
        failed: ActionType.FETCH_ROLLOUT_VERSION_FAILED,
      },
    },
  });
